import { useEffect } from "react";
import Cal, { getCalApi } from "@calcom/embed-react";
import Header from "../../components/feature/Header";
import Footer from "../home/components/Footer";

export default function DemoPage() {
    useEffect(() => {
        (async function () {
            const cal = await getCalApi({ namespace: "30min" });
            cal("ui", {
                theme: "light",
                cssVarsPerTheme: {
                    light: { "cal-brand": "#2784C7" }
                },
                hideEventTypeDetails: false,
                layout: "month_view"
            });
        })();
    }, []);

    return (
        <div className="min-h-screen flex flex-col bg-slate-50">
            <Header />

            <main className="flex-1 pt-32 pb-20 px-4">
                <div className="max-w-4xl mx-auto">
                    <div className="text-center mb-12">
                        <h1 className="text-4xl md:text-5xl font-bold text-[#0F172A] mb-4" style={{ fontFamily: 'Inter Tight, sans-serif' }}>
                            Live Demo buchen
                        </h1>
                        <p className="text-lg text-slate-600 max-w-2xl mx-auto" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                            Wählen Sie einen passenden Termin aus und lassen Sie uns gemeinsam herausfinden, wie Reputrust Ihr Bewertungsmanagement automatisieren kann.
                        </p>
                    </div>

                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-100 h-[700px]">
                        <Cal
                            namespace="30min"
                            calLink="simon-mueller/30min"
                            style={{ width: "100%", height: "100%", overflow: "scroll" }}
                            config={{
                                layout: "month_view",
                                useSlotsViewOnSmallScreen: "true",
                                theme: "light"
                            }}
                        />
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}
